import { ChangeDetectionStrategy, Component } from '@angular/core';
import {faArrowUpRightFromSquare, faFileWord} from "@fortawesome/free-solid-svg-icons";
import {Title} from "@angular/platform-browser";

type Guide = {
  title: string;
  size: string;
  href: string;
  fileType?: 'word' | 'pdf' | 'generic';
}

@Component({
  selector: 'app-support',
  standalone: false,
  templateUrl: './support.component.html',
  styleUrl: './support.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class SupportComponent {

  constructor(
    private readonly titleService: Title,
  ) {
    titleService.setTitle('BAER - Support')
  }
  guides: Guide[] = [
    { title: 'BAER Fire Tracker User Guide', size: '1.2 MB', href: 'https://usdagcc.sharepoint.com/:w:/s/fs-baer/EY13dpJqq1tNs2vgCoQ0YcQB7_NIZFwMcBsW69b4q-aqLQ?e=6cpAo9', fileType: 'word' },
    { title: 'BAER Fire Roster User Guide', size: '5.7 MB', href: 'https://usdagcc.sharepoint.com/:w:/s/fs-baer/EbvaPpbnEQ5KusDI2Hh_xZYBnPWJKYG6gT0ATQeesOa9KQ?e=FIvhOc', fileType: 'word' },
    { title: 'BAER Teams Tab User Guide', size: '1.2 MB', href: 'https://usdagcc.sharepoint.com/:w:/s/fs-baer/EZ70gWOu0iVHrnh_HDVXu6gBgNwqvB6r4NguedqMUOqB4Q?e=pfaY3A', fileType: 'word' },
    { title: 'BAER Assessment User Guide', size: '1.4 MB', href: 'https://usdagcc.sharepoint.com/:w:/s/fs-baer/EcIe3qGsq45Miz19mHop_FwBE6BdiRTTuIibUdMC2L-G6Q?e=WXMNXa', fileType: 'word' },
    { title: 'BAER 2500-8 Report User Guide', size: '2.1 MB', href: 'https://usdagcc.sharepoint.com/:w:/s/fs-baer/EbnHwqdjpbROkw0AAHP5ygwBkpyGzrt6T0lI3EyKiIipcQ?e=nafHt5', fileType: 'word' },
    { title: 'BAER No Treatment Recommendations User Guide', size: '2.1 MB', href: 'https://usdagcc.sharepoint.com/:w:/s/fs-baer/EcfCjdVbgh5GrGc1l1P_80sBIlux5ePcjxgelHBx58X-tg?e=MgPfsg', fileType: 'word' },
    { title: 'BAER Pre-Assessment User Guide', size: '2.1 MB', href: 'https://usdagcc.sharepoint.com/:w:/s/fs-baer/ES0V257YhetDvcsJlJk2XGsBz4s7Os1V3IJnE2CpcgJIPw?e=9rFrOT', fileType: 'word' },
    { title: 'BAER 2500-8 Report RO Funding User Guide', size: '1.4 MB', href: 'https://usdagcc.sharepoint.com/:w:/s/fs-baer/Eds1cxISzNtGkIDHRjQLifEBAn9FHByxFuAN4kFXf2djFQ?e=vCROgm', fileType: 'word' },
    { title: 'BAER 2500-8 Report WO Funding User Guide', size: '1.4 MB', href: 'https://usdagcc.sharepoint.com/:w:/s/fs-baer/EdphXYA3RFtJmSxS9hHbzcsBOtUl7pcZp-Kkk1xdR7rxgQ?e=Xvonxe', fileType: 'word' },
    { title: 'BAER Reports User Guide', size: '1.4 MB', href: 'https://usdagcc.sharepoint.com/:w:/r/sites/fs-baer/BAER%20Application%20Documents/BAER-Reports-User-Guide.docx?d=we636b7eab4754d3b81e26a1b723dfc8a&csf=1&web=1&e=Lmogur', fileType: 'word' },
    { title: 'BAER Accomplishment Report User Guide', size: '1.4 MB', href: 'https://usdagcc.sharepoint.com/:w:/s/fs-baer/EehcBVIZSFNGkZnaq81xBfABPKqw25oA1z3OksxeWFKDEA?e=ysynxk', fileType: 'word' },
  ];

  get guidePairs() {
    const pairs = [];
    for (let i = 0; i < this.guides.length; i += 2) {
      pairs.push({
        left: this.guides[i],
        right: this.guides[i+1]
      })
    }
    return pairs;
  }

  protected readonly faArrowUpRightFromSquare = faArrowUpRightFromSquare;
  protected readonly faFileWord = faFileWord;
}
